import firebase from '../../firebase';

export default async function createStripeSetupIntent(userId) {
    const result = await firebase.functions().httpsCallable('billing-createStripeSetupIntent')({ userId });
    if (result && result.data) {
        return result.data.clientSecret;
    }
    return undefined;
}
